import { Defect } from '../../../state/models';
import { get, httpDelete, post } from '../../../utils/api';

const apiEndpoint = '/api/defects';

export async function loadAll(): Promise<Defect[]> {
    return get<Defect[]>(`${apiEndpoint}`);
}